import type PassportsShow from "@travily/types/pages/PassportsShow";
import type { ReactNode } from "react";
import { RoutedModal } from "@/components/RoutedModal";
import { BadgesModal } from "./show.view";

const PassportShowPage = ({ badges }: PassportsShow) => (
  <RoutedModal size="xl" chrome="bare">
    {({ close }) => <BadgesModal badges={badges} onClose={close} />}
  </RoutedModal>
);

PassportShowPage.layout = (page: ReactNode) => page;

export default PassportShowPage;
